/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  plus: {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data:
      '<path pid="0" _fill="#313030" fill-rule="evenodd" d="M14.148 14.148H8.98v2.385h5.168V21.7h2.385v-5.167H21.7v-2.385h-5.167V8.98h-2.385v5.168zM30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15C0 6.716 6.716 0 15 0c8.284 0 15 6.716 15 15z"/>'
  }
})
